export const BiReportType = {
  TABLE: 'TABLE',
  PIE: 'PIE',
  DOUGHNUT: 'DOUGHNUT',
  LINE: 'LINE',
  BAR: 'BAR',
  COMBO: 'COMBO',
  HORIZONTAL: 'HORIZONTAL',
  KPI: 'KPI',
  STACKED_BAR: 'STACKED_BAR',
};

export const BiReportTypeList = [
  { label: 'Táblázat', value: BiReportType.TABLE },
  { label: 'Kör', value: BiReportType.PIE },
  { label: 'Fánk', value: BiReportType.DOUGHNUT },
  { label: 'Vonal', value: BiReportType.LINE },
  { label: 'Oszlop', value: BiReportType.BAR },
  { label: 'Kombinált', value: BiReportType.COMBO },
  { label: 'Vízszintes oszlop', value: BiReportType.HORIZONTAL },
  { label: 'KPI', value: BiReportType.KPI },
  { label: 'Halmozott oszlop', value: BiReportType.STACKED_BAR },
];

export const BiChartType = {
  LINE: 'LINE',
  BAR: 'BAR',
};

export const BiChartTypeList = [
  { label: 'Vonal', value: BiChartType.LINE },
  { label: 'Oszlop', value: BiChartType.BAR },
];

export const BiFieldType = {
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  TIME: 'TIME',
  HIDDEN: 'HIDDEN',
  CURRENCY: 'CURRENCY',
  COLOR: 'COLOR',
  QUANTITY: 'QUANTITY',
  PRICE: 'PRICE',
  SUM: 'SUM',
  CALCULATED: 'CALCULATED',
  CONDITIONAL: 'CONDITIONAL',
};

export const BiFieldTypeList = [
  { label: 'Szám', value: BiFieldType.NUMBER },
  { label: 'Szöveg', value: BiFieldType.STRING },
  { label: 'Dátum', value: BiFieldType.DATE },
  { label: 'Dátum, idő', value: BiFieldType.DATETIME },
  { label: 'Idő', value: BiFieldType.TIME },
  { label: 'Rejtett', value: BiFieldType.HIDDEN },
  { label: 'Pénznem', value: BiFieldType.CURRENCY },
  { label: 'Szín', value: BiFieldType.COLOR },
  { label: 'Mennyiség', value: BiFieldType.QUANTITY },
  { label: 'Ár', value: BiFieldType.PRICE },
  { label: 'Összeg', value: BiFieldType.SUM },
  { label: 'Számolt', value: BiFieldType.CALCULATED },
  { label: 'Feltételes', value: BiFieldType.CONDITIONAL },
];

export const BiConditionOperator = {
  EQ: 'EQ',
  NE: 'NE',
  LT: 'LT',
  LTE: 'LTE',
  GT: 'GT',
  GTE: 'GTE',
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  STARTS_WITH: 'STARTS_WITH',
  ENDS_WITH: 'ENDS_WITH',
  IS_NULL: 'IS_NULL',
  IS_NOT_NULL: 'IS_NOT_NULL',
};

export const BiConditionOperatorList = [
  { label: '=', value: BiConditionOperator.EQ },
  { label: '≠', value: BiConditionOperator.NE },
  { label: '<', value: BiConditionOperator.LT },
  { label: '≤', value: BiConditionOperator.LTE },
  { label: '>', value: BiConditionOperator.GT },
  { label: '≥', value: BiConditionOperator.GTE },
  { label: 'Tartalmazza', value: BiConditionOperator.CONTAINS },
  { label: 'Nem tartalmazza', value: BiConditionOperator.NOT_CONTAINS },
  { label: 'Ezzel kezdődik', value: BiConditionOperator.STARTS_WITH },
  { label: 'Erre végződik', value: BiConditionOperator.ENDS_WITH },
  { label: 'Üres', value: BiConditionOperator.IS_NULL },
  { label: 'Nem üres', value: BiConditionOperator.IS_NOT_NULL },
];
export const BiAnalysisType = {
  COUNT: 'COUNT',
  SUM: 'SUM',
  AVG: 'AVG',
  MAX: 'MAX',
  MIN: 'MIN',
};

export const BiAnalysisTypeList = [
  { label: 'Számolt', value: BiAnalysisType.COUNT },
  { label: 'Összeg', value: BiAnalysisType.SUM },
  { label: 'Átlag', value: BiAnalysisType.AVG },
  { label: 'Maximum', value: BiAnalysisType.MAX },
  { label: 'Minimum', value: BiAnalysisType.MIN },
];

export const BiOrderType = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const BiOrderTypeList = [
  { label: 'Növekvő', value: BiOrderType.ASC },
  { label: 'Csökkenő', value: BiOrderType.DESC },
];

export const BiFilterFieldType = {
  LIKE: 'LIKE',
  GT: 'GT',
  GTE: 'GTE',
  LT: 'LT',
  LTE: 'LTE',
  EQ: 'EQ',
  NOTLIKE: 'NOTLIKE',
  NOTEQ: 'NOTEQ',
};

export const BiFilterFieldTypeList = [
  { label: 'LIKE', value: BiFilterFieldType.LIKE },
  { label: 'NOT LIKE', value: BiFilterFieldType.NOTLIKE },
  { label: '>', value: BiFilterFieldType.GT },
  { label: '>=', value: BiFilterFieldType.GTE },
  { label: '<', value: BiFilterFieldType.LT },
  { label: '<=', value: BiFilterFieldType.LTE },
  { label: '=', value: BiFilterFieldType.EQ },
  { label: '!=', value: BiFilterFieldType.NOTEQ },
];

export const BiWritebackInputType = {
  STRING: 'STRING',
  TEXTAREA: 'TEXTAREA',
  INTEGER: 'INTEGER',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  BOOLEAN: 'BOOLEAN',
};

export const BiWritebackInputTypeList = [
  { label: 'Szöveg', value: BiWritebackInputType.STRING },
  { label: 'Többsoros szöveg', value: BiWritebackInputType.TEXTAREA },
  { label: 'Egész szám', value: BiWritebackInputType.INTEGER },
  { label: 'Tizedes szám', value: BiWritebackInputType.DECIMAL },
  { label: 'Dátum', value: BiWritebackInputType.DATE },
  { label: 'Dátum, idő', value: BiWritebackInputType.DATETIME },
  { label: 'Logikai érték', value: BiWritebackInputType.BOOLEAN },
];
